var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "wrapper" }, [
    _c("div", { staticClass: "lines mb-1" }, [
      _c("div", { staticClass: "account-code" }, [
        _c("strong", { staticClass: "text-secondary-light" }, [
          _vm._v(
            "\n        " +
              _vm._s(_vm.$t("apps.accounting.label.select_account")) +
              "\n      "
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "debit-credit" }, [
        _c("div", { staticClass: "d-flex" }, [
          _c(
            "strong",
            {
              staticClass: "text-secondary-light w-50 text-right",
              class: [_vm.labelTotalColor]
            },
            [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.getNumber(_vm.totalDebit)) +
                  "\n          " +
                  _vm._s(_vm.$t("apps.accounting.label.debit")) +
                  "\n        "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "strong",
            {
              staticClass: "text-secondary-light w-50 text-right",
              class: [_vm.labelTotalColor]
            },
            [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.getNumber(_vm.totalCredit)) +
                  "\n          " +
                  _vm._s(_vm.$t("apps.accounting.label.credit")) +
                  "\n        "
              )
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "label" }, [
        _c("strong", { staticClass: "text-secondary-light" }, [
          _vm._v(
            "\n        " +
              _vm._s(_vm.$t("apps.accounting.label.label")) +
              "\n      "
          )
        ])
      ]),
      _vm._v(" "),
      !_vm.disabled
        ? _c("div", { staticClass: "delete" }, [_vm._v("\n       \n    ")])
        : _vm._e()
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "form" },
      _vm._l(_vm.$v.form.lines.$each.$iter, function(line, lineIndex) {
        return _c("div", { key: lineIndex, staticClass: "lines mb-3" }, [
          _c(
            "div",
            { staticClass: "account-code" },
            [
              _c("vue-bootstrap-autocomplete", {
                attrs: {
                  data: _vm.filterAccountOptions,
                  serializer: function(item) {
                    return item.text
                  },
                  minMatchingChars: 0,
                  showCreate: false,
                  showOnFocus: true,
                  maxMatches: 500,
                  state: (function() {
                    if (line.account_code.$error && lineIndex == 0) {
                      return false
                    }
                    return null
                  })(),
                  disabled: _vm.disabled
                },
                on: {
                  input: function($event) {
                    return _vm.handleInputAccount(lineIndex, $event)
                  },
                  hit: function($event) {
                    return _vm.handleSelectAccount(lineIndex, $event)
                  },
                  keydown: function($event) {
                    return _vm.handleKeydownAccount(lineIndex, $event)
                  },
                  keyup: function($event) {
                    return _vm.handleKeyupAccount(lineIndex, $event)
                  },
                  inputBlur: function($event) {
                    return _vm.handleInputBlurAccount(lineIndex, $event)
                  }
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "suggestion",
                      fn: function(ref) {
                        var data = ref.data
                        var htmlText = ref.htmlText
                        return [
                          _c(
                            "div",
                            { staticClass: "d-flex align-items-center" },
                            [
                              _c("div", { staticClass: "d-flex flex-column" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(data.text) +
                                    "\n              "
                                )
                              ])
                            ]
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  true
                ),
                model: {
                  value: line.$model.query,
                  callback: function($$v) {
                    _vm.$set(line.$model, "query", $$v)
                  },
                  expression: "line.$model.query"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "debit-credit" }, [
            _c("div", { staticClass: "input-group" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: line.$model.debit,
                    expression: "line.$model.debit"
                  }
                ],
                staticClass: "form-control text-right text-select-all",
                attrs: {
                  disabled:
                    !line.$model.account_code ||
                    Number(line.$model.credit) != 0 ||
                    _vm.disabled,
                  type: "text"
                },
                domProps: { value: line.$model.debit },
                on: {
                  keypress: _vm.numberOnly,
                  keyup: function($event) {
                    line.$model.debit = _vm.setToValidNumber(line.$model.debit)
                  },
                  blur: function($event) {
                    line.$model.debit = _vm.setToCustomDigitsNumber(
                      line.$model.debit
                    )
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(line.$model, "debit", $event.target.value)
                  }
                }
              }),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: line.$model.credit,
                    expression: "line.$model.credit"
                  }
                ],
                staticClass: "form-control text-right text-select-all",
                attrs: {
                  disabled:
                    !line.$model.account_code ||
                    Number(line.$model.debit) != 0 ||
                    _vm.disabled,
                  type: "text"
                },
                domProps: { value: line.$model.credit },
                on: {
                  keypress: _vm.numberOnly,
                  keyup: function($event) {
                    line.$model.credit = _vm.setToValidNumber(
                      line.$model.credit
                    )
                  },
                  blur: function($event) {
                    line.$model.credit = _vm.setToCustomDigitsNumber(
                      line.$model.credit
                    )
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(line.$model, "credit", $event.target.value)
                  }
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "label" },
            [
              !line.$model.account_code || _vm.disabled
                ? _c("BaseInput", {
                    attrs: {
                      value: _vm.getMasterDataText(line.$model.label, _vm.$t),
                      disabled: true
                    }
                  })
                : _c("BaseInput", {
                    attrs: { disabled: false },
                    model: {
                      value: line.$model.label,
                      callback: function($$v) {
                        _vm.$set(line.$model, "label", $$v)
                      },
                      expression: "line.$model.label"
                    }
                  })
            ],
            1
          ),
          _vm._v(" "),
          !_vm.disabled
            ? _c(
                "div",
                { staticClass: "delete" },
                [
                  _c(
                    "BaseButton",
                    {
                      staticClass: "w-100",
                      attrs: { disabled: _vm.disabled },
                      on: {
                        click: function($event) {
                          return _vm.removeLine(lineIndex)
                        }
                      }
                    },
                    [_c("i", { staticClass: "far fa-trash-alt" })]
                  )
                ],
                1
              )
            : _vm._e()
        ])
      }),
      0
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "actions mt-3" },
      [
        !_vm.disabled
          ? _c(
              "BaseButton",
              {
                on: {
                  click: function($event) {
                    return _vm.addLine()
                  }
                }
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.$t("apps.accounting.button.addjournalentryline")
                    ) +
                    "\n    "
                )
              ]
            )
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-39bdcea6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39bdcea6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/custom/JournalEntryLine.vue
// module id = null
// module chunks = 